import { ENDPOINTS } from "@/shared/constants/endpoint";
import { postData } from "@/shared/lib/axiosHelper";
import { DashboardStatisticsResponse, PayloadDashboardStatistics } from "@/shared/model/dashboard/dashboard";

const getDashboardStatistics = async (data: PayloadDashboardStatistics) => {
  try {
    const res = await postData({
      endpoint: ENDPOINTS.DASHBOARD.DASHBOARD_STATISTICS,
      data,
    });

    return res?.data?.data as DashboardStatisticsResponse;
  } catch (error: any) {
    console.error("Error get dashboard statistics:", error);
    throw error;
  }
};

export { getDashboardStatistics };
